module.exports = __webpack_public_path__ + "img/zm.9f7358c5.svg";